<template>
  <section class="member">
    <span class="total">{{$t('global.共x个成员',{count:memberCount})}}</span>
    <div class="member-list">
      <ul>
        <li v-for="item in memberList" :key="item.id">
          <MemberCard :item="item" />
        </li>
      </ul>
      <Loading v-if="loading" />
      <Reload v-if="loadError" @callback="loadMore" />
      <no-more v-if="!hasNextPage && memberList.length" />
    </div>
  </section>
</template>

<script>
import MemberCard from "@/components/v2/match/memberCard";
import Reload from "@/components/v2/match/reload";
import NoMore from "@/components/v2/NoMore";
import Loading from "@/components/v2/match/loading";
import {
  getScrollHeight,
  getScrollTop,
  getWindowHeight
} from "@/assets/screen";
export default {
  components: {
    MemberCard,
    Reload,
    NoMore,
    Loading
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  data() {
    return {
      loading: false,
      hasMore: true,
      loadError: false,
      hasNextPage: true,
      memberList: [],
      memberCount: 0,
      pageIndex: 1,
      pageSize: 10
    };
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener("scroll", this.loadMore);
  },
  destroyed() {
    window.removeEventListener("scroll", this.loadMore, false);
  },
  methods: {
    init() {
      this.topicId = this.$route.params.id;
      this.getMemberList();
    },
    loadMore() {
      if (getScrollTop() + getWindowHeight() >= getScrollHeight() - 20) {
        if (!this.loading && this.hasNextPage) {
          this.pageIndex++;
          this.getMemberList();
        }
      }
    },
    getMemberList() {
      this.loading = true;
      const url = "/api/topic/getMemberListByParms";
      const params = {
        topicId: this.topicId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        orderBy: 1,
        isSl: 1,
        indexOf: 1,
        roleIds: "0,1,2,3"
      };
      this.$http.get(url, { params }).then(res => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          this.memberList = [...this.memberList, ...res.data.list];
          this.memberCount = res.data.totalRecord;
          this.hasNextPage = res.data.hasNextPage;
        } else {
          this.pageIndex--;
          this.loadError = true;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
.member {
  .total {
    color: #999999;
    font-size: 15px;
    font-weight: 500;
    padding: 30px 0 10px;
    display: block;
  }

  .member-list {
    padding-bottom: 40px;

    ul {
      display: flex;
      flex-direction: column;
      padding-bottom: 20px;

      li {
        display: block;
        border-bottom: 1px solid #EBEBEB;
        padding: 30px 0;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/subject/channel/Member.vue